module.exports = __webpack_public_path__ + "media/whats_your_status_series_successful_internship_search_tips/successful_internship_search_tips-86490f0a.jpg";